"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBarComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `${(0, fast_element_1.when)(x => x.isVisible, (0, fast_element_1.html) `<div class="progress-bar-container">
    <div class="progress-track">
        <div class="progress-fill" style="width: ${x => x.progress}%"></div>
    </div>
</div>`)}
`;
require("./styles/layout.scss");
const styles = T.css `.progress-bar-container {
  padding: 5px;
  margin: 8px 0;
  transition: all 0.3s ease;
}
.progress-bar-container .progress-track {
  width: 100%;
  height: 8px;
  background: var(--color-background-secondary, #f7fafc);
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}
.progress-bar-container .progress-track .progress-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--primary-color), var(--alt_blu));
  border-radius: 4px;
  transition: width 0.3s ease;
  position: relative;
}
.progress-bar-container .progress-track .progress-fill::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}`;
const shadowOptions = { "mode": "open" };
let ProgressBarComponent = class ProgressBarComponent extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.progress = 0;
        this.message = '';
        this.stage = '';
        this.isVisible = false;
    }
    /**
     * Update the progress bar with new values
     * @param progress - Progress percentage (0-100)
     * @param message - Message to display
     * @param stage - Current stage
     */
    updateProgress(progress, message, stage = '') {
        this.progress = progress;
        this.message = message;
        this.stage = stage;
        this.isVisible = true;
    }
    /**
     * Hide the progress bar
     */
    hide() {
        this.isVisible = false;
    }
    /**
     * Show the progress bar
     */
    show() {
        this.isVisible = true;
    }
    /**
     * Reset the progress bar to initial state
     */
    reset() {
        this.progress = 0;
        this.message = '';
        this.stage = '';
        this.isVisible = false;
    }
    connectedCallback() {
        super.connectedCallback();
    }
};
exports.ProgressBarComponent = ProgressBarComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], ProgressBarComponent.prototype, "progress", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], ProgressBarComponent.prototype, "message", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], ProgressBarComponent.prototype, "stage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ProgressBarComponent.prototype, "isVisible", void 0);
exports.ProgressBarComponent = ProgressBarComponent = __decorate([
    (0, client_1.RWSView)('progress-bar', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], ProgressBarComponent);
ProgressBarComponent.defineComponent();
